(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    if (!form || !form.querySelector('#AS-shape')) return;
    const shape = form.querySelector('#AS-shape');
    const width = form.querySelector('#AS-width');
    const reel = form.querySelector('#AS-reel');
    const details = form.querySelector('#AS-reel-details');
    const update = () => {
      const round = shape.value === 'Rund';
      width.closest('[data-field]').hidden = round;
      width.disabled = round;
      width.required = !round;
      const eight = form.querySelector('[data-eight-note]');
      eight.hidden = shape.value !== 'Achtform';
      details.hidden = !reel.checked;
      reel.setAttribute('aria-expanded', String(reel.checked));
      details.querySelectorAll('input, select').forEach(field => { field.disabled = !reel.checked; });
      for (const field of form.querySelectorAll('[data-measure]')) {
        const number = Number(field.value.replace(',', '.'));
        field.setCustomValidity(!field.disabled && field.value && (!(number > 0) || number > 50) ? root.dataset.invalidMeasure : '');
      }
    };
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', event => {
      update();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      const button = form.querySelector('[type="submit"]');
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.submittingLabel;
    });
    window.addEventListener('pageshow', () => {
      update();
      const button = form.querySelector('[type="submit"]');
      button.removeAttribute('aria-busy');
      button.textContent = button.dataset.submitLabel;
    });
    update();
  }
  document.querySelectorAll('[data-ap-solar-enquiry]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ap-solar-enquiry]').forEach(init));
})();
